import { uniqBy, xorBy } from "lodash";
import { useState, MouseEvent } from "react";
import { FilterOption } from "shared/components/Filter";
import { useAnchorEl } from "shared/hooks/useAnchorEl";

export const useFilterApi = <T extends Record<string, any>>(
  data: T[],
  filterByKey: keyof T & string,
) => {
  const [selectedValues, setSelectedValues] = useState<FilterOption[]>([]);
  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  const fullOptionsList = uniqBy(data, filterByKey).map(
    (item) =>
      ({
        label: item[filterByKey],
        value: item[filterByKey]?.trim().toLocaleLowerCase(),
      }) as FilterOption,
  );

  const handleChangeValue = (
    _: MouseEvent<HTMLElement>,
    option: FilterOption,
  ) => setSelectedValues((prevStatus) => xorBy(prevStatus, [option], "value"));

  const onClearSelectedValues = () => setSelectedValues([]);

  return {
    filteredValues: selectedValues.map((item) => item.value) ?? [],
    setFilteredValues: setSelectedValues,
    filterData: {
      options: fullOptionsList,
      anchorEl,
      open,
      selectedValue: selectedValues,
      handleOpenMenu: handleAnchorOpen,
      handleChangeValue,
      handleClose: handleAnchorClose,
      onClearSelectedValues,
    },
  };
};
